'use strict';

const { valueIsNotNull } = require('./localisation-parser');

function getCategoryDetails({ categoryIds, I18n }) {
  if (!Array.isArray(categoryIds) || !categoryIds.length) {
    return {};
  }

  const categoryName = categoryIds.reduce((category, categoryId) => {
    const locale = I18n.t(`js.modules.category.Name.${categoryId}`);
    if (!category && valueIsNotNull(locale)) {
      category = locale;
    }
    return category;
  }, null);

  if (!categoryName) {
    return {};
  }

  return {
    categoryName,
  };
}

function getCategoryNames({ categoryIds, I18n, limit }) {
  const categoryNames = [];

  if (!Array.isArray(categoryIds) || !categoryIds.length) {
    return categoryNames;
  }

  categoryIds.slice(0, limit).forEach(id => {
    const categoryName = I18n.t(`js.modules.category.Name.${id}`);
    if (valueIsNotNull(categoryName)) {
      categoryNames.push(categoryName);
    }
  });

  return categoryNames;
}

function getRelatedTableClass(coupons, amountBeforeInlineContent) {
  if (Array.isArray(coupons) && coupons.length <= amountBeforeInlineContent) {
    return 'category-related-item-last';
  }

  return 'category-related-item';
}

module.exports = {
  getCategoryDetails,
  getCategoryNames,
  getRelatedTableClass,
};
